var getAllCollections = function getAllCollections(state) {
  return state.resources.collections;
};
var getAllExternalResources = function getAllExternalResources(state) {
  return state.resources.externalResources;
};
var getAllLayers = function getAllLayers(state) {
  return state.resources.layers;
};
var getAllServices = function getAllServices(state) {
  return state.resources.services;
};
var getAllManifests = function getAllManifests(state) {
  return state.resources.manifests;
};
var getAllSequences = function getAllSequences(state) {
  return state.resources.sequences;
};
var getAllRanges = function getAllRanges(state) {
  return state.resources.ranges;
};
var getAllCanvases = function getAllCanvases(state) {
  return state.resources.canvases;
};
var getAllCanvasReferences = function getAllCanvasReferences(state) {
  return state.resources.canvasReferences;
};
var getAllImages = function getAllImages(state) {
  return state.resources.imageResources;
};
var getAllAnnotations = function getAllAnnotations(state) {
  return state.resources.annotations;
};
var getAllAnnotationLists = function getAllAnnotationLists(state) {
  return state.resources.annotationLists;
};
var getAllAnnotationPages = function getAllAnnotationPages(state) {
  return state.resources.annotationPages;
};
var getAllAnnotationCollections = function getAllAnnotationCollections(state) {
  return state.resources.annotationCollections;
};
var getAllChoices = function getAllChoices(state) {
  return state.resources.choices;
};
var getAllContentResources = function getAllContentResources(state) {
  return state.resources.contentResources;
};
var getAllResources = function getAllResources(state) {
  return state.resources;
};
var getAllSchemaVersions = function getAllSchemaVersions(state) {
  return state.resources.schemaVersions;
};
var getAllDereferenced = function getAllDereferenced(state) {
  return state.dereferenced;
};
var getAllSelectors = function getAllSelectors(state) {
  return state.selectors;
};

export { getAllCollections, getAllExternalResources, getAllLayers, getAllServices, getAllManifests, getAllSequences, getAllRanges, getAllCanvases, getAllCanvasReferences, getAllImages, getAllAnnotationLists, getAllAnnotationPages, getAllAnnotationCollections, getAllAnnotations, getAllChoices, getAllContentResources, getAllResources, getAllSchemaVersions, getAllDereferenced, getAllSelectors };